import { useEffect, useState } from 'react'
import { isLightColor } from '../../lib/script'
import classes from './TagImproved.module.css'

const TagImproved = ({children, color, colorCode}) => {

    const [textColor, setTextColor] = useState(null)

    useEffect(() => {
        if (colorCode) {
            let lightDark = isLightColor(colorCode)
            setTextColor(lightDark ? 'var(--text)' : 'var(--white)')
            
        }
    }, [colorCode])

    return <div className={`${classes.tag_improved} ${color ? 'bk_' + color.split(' ').join('_') : classes.no_color} `} style={{backgroundColor: colorCode, color: textColor}}>{children}</div>
}

export default TagImproved